<ion-app>
  <ion-router-outlet [attr.inert]="objPrinterRecovery() ? '' : null"></ion-router-outlet>
  <app-printer-recovery [objProgress]="objPrinterRecovery()"
    [strMessageKey]="objPrinterRecovery()?.strMessageKey ?? ''"></app-printer-recovery>
</ion-app>
